// @file get current user info
import window, { ww } from 'bits/global'

class UserHelpers {
  role: string
  constructor(role_name: string) {
    this.role = role_name
  }
  isAdmin(): boolean {
    return ['owner', 'admin', 'teacher'].indexOf(this.role) > -1
  }
  isOwner(): boolean {
    return this.role === 'owner'
  }
}

let currentUser = window.$currentUser
if (!currentUser) {
  if (ww && ww.xstore) {
    currentUser = ww.xstore.state.user
  }
}

if (!currentUser && ww && ww.vueStartingState) {
  currentUser = ww.vueStartingState.user
}

if (!currentUser) {
  currentUser = { id: null }
}

const userHelpers = new UserHelpers(currentUser.role || '')
export default Object.assign(userHelpers, currentUser)
